import React, { FC, useEffect, useState } from 'react'
import classNames from 'classnames'

import { useSelector } from 'react-redux'
import { isViewingDvrFromBeginningSelector } from 'redux-store/userInterface/userInterface.selectors'
import { streamSelector } from 'redux-store/stream/stream.selectors'
import { channelSelector } from 'redux-store/channel/channel.selectors'

import { TopActionsBar } from '../components/TopActionsBar/TopActionsBar'
import { StreamMessage } from '../components/StreamMessage/StreamMessage'
import {
  Breakpoint,
  getWidth,
  useCurrentBreakpoint
} from 'hooks/CurrentBreakpoint'
import { StreamNavigation } from '../components/StreamNavigation/StreamNavigation'
import { VideoPlayerPreloader } from '../components/VideoPlayerPreloader/VideoPlayerPreloader'
import VideoPlayer from 'components/video/VideoPlayer'
import styles from './StreamPlayingView.module.scss'
import { ConditionalRender } from 'components/ConditionalRender/ConditionalRender'

export const StreamPlayingView: FC = () => {
  const stream = useSelector(streamSelector)
  const channel = useSelector(channelSelector)
  const viewDvrFromBeginning = useSelector(isViewingDvrFromBeginningSelector)
  const seekTo = viewDvrFromBeginning ? 0 : undefined
  const isRootOrClubChannel = channel?.data?.isRootClubChannel
  const isRootOrChild =
    channel?.data?.isRootChannel || channel?.data?.isChildOfRootChannel
  const currentBreakpoint = useCurrentBreakpoint()
  const isMobile = currentBreakpoint <= Breakpoint.sm
  const screenWidth = getWidth()
  const videoPlayerHeight = screenWidth * 0.5625

  const [videoHeight, setVideoHeight] = useState(videoPlayerHeight)
  useEffect(() => {
    setVideoHeight(screenWidth * 0.5625)
  }, [screenWidth])
  const mediaPlayerData = stream.data
  return (
    <div
      className={classNames(styles.OuterContainer, {
        [styles.IsRootOrChild]: isRootOrChild,
        [styles.IsRootClubChannel]: isRootOrClubChannel
      })}
    >
      <div className={styles.Container}>
        <ConditionalRender web={false}>
          <div style={{ height: '65px', backgroundColor: '#ffffff' }}></div>
        </ConditionalRender>
        <StreamMessage />
        <div className={styles.InnerContainer}>
          <div className={styles.VideoContainer}>
            <div className={styles.TopActionsBar}>
              <TopActionsBar />
            </div>
            {mediaPlayerData &&
            mediaPlayerData.streamUrl !== null &&
            mediaPlayerData.streamUrl.urls &&
            mediaPlayerData.streamUrl.urls.hls &&
            mediaPlayerData.streamUrl.urls.dash ? (
              <div className={styles.VideoPlayer}>
                <VideoPlayer
                  mediaObject={mediaPlayerData.mediaObject}
                  streamUrls={mediaPlayerData.streamUrl!.urls}
                  autoPlay={false}
                  seekTo={seekTo}
                />
              </div>
            ) : (
              <VideoPlayerPreloader />
            )}
          </div>
          <div
            style={{ paddingBottom: isMobile ? videoHeight : 0 }}
            className={styles.Navigation}
          >
            <StreamNavigation />
          </div>
        </div>
      </div>
    </div>
  )
}
